import { get } from './shared';

export const presignedUrl = async () => {
  const url = `attachments/cache/presign`;
  return await get(url);
};
